import { FC, useEffect, useState } from 'react'
import classNames from 'classnames'
import { ProgressBarProps as Props } from './types'
import styles from './ProgressBar.module.scss'

const ProgressBar: FC<Props> = ({ current, isGrey, className }) => {
  // Local state
  const [rendered, setRendered] = useState<boolean>(false)

  /**
   * Triggered after first render
   */
  useEffect(() => {
    setRendered(true)
  }, [])

  return (
    <div className={classNames(styles['progress-bar'], className, { [styles['is-grey']]: isGrey })}>
      <div className={styles['progress-bar-inner']} style={{ width: `${rendered ? Math.round(current) : 0}%` }} />
    </div>
  )
}

ProgressBar.defaultProps = {
  className: '',
  isGrey: false
}

export default ProgressBar
